/* eslint-disable react/no-danger */
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import styles from './SitemapSection.scss';

const SitemapSection = ({ data, header = '' }) => (
  <section className={styles.component}>
    {header && <h2>{header}</h2>}
    <div>
      <ul>
        { data.map(({ link, title }) => (
          <li key={link}>
            <Link to={link}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

SitemapSection.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  header: PropTypes.string,
};

export default SitemapSection;
